import { Box, Divider, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import { PlaidContainer } from 'borrower/domains/bankIntegrations/ui/plaid/PlaidContainer';
import { TellerContainer } from 'borrower/domains/bankIntegrations/ui/teller/TellerContainer';
import { PageHeader } from 'packages/common-frontend/components/PageContainer';

export const BankIntegrationViewContainer = ({
  borrowerKey,
  cashBalancePreference,
}: {
  borrowerKey: string;
  cashBalancePreference: 'current' | 'available';
}) => {
  return (
    <Box>
      <PageHeader headerLabel="Connect your bank accounts" />
      <Text width="100%" mt="10px" fontSize="sm" align="left">
        Institution accounts are an important data source for debt capital
        compliance and monitoring.
      </Text>
      <Text fontSize="sm" mb="10px" align="left">
        To connect a bank account to Finley, click on the button with the
        appropriate data provider below.
      </Text>
      <Box>
        <Divider m="25px 0" orientation="horizontal" />
        <Heading as="h4" size="md" textAlign="left" marginBottom="30px">
          Plaid Connections
        </Heading>
        <PlaidContainer cashBalancePreference={cashBalancePreference} />
      </Box>
      <Box>
        <Divider m="25px 0" orientation="horizontal" />
        <Heading as="h4" size="md" textAlign="left" marginBottom="30px">
          Teller Connections
        </Heading>
        <TellerContainer
          borrowerKey={borrowerKey}
          cashBalancePreference={cashBalancePreference}
        />
      </Box>
    </Box>
  );
};
